// Standalone-ingang voor SharePoint-analyse, zodat het los toewijsbaar is
// (recht `sharepoint_analyse`) buiten de admin-omgeving. Rendert dezelfde tool
// als de admin-sectie, in een normale pagina-container.
import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../ui-components/PageHeader';
import SharePointAnalysis from './AdminSettings/sections/SharePointAnalysis';

export default function SharePointAnalysePage() {
  return (
    <Box sx={{ width: '100%', maxWidth: 1400, mx: 'auto', px: { xs: 2, md: 3 }, py: 3 }}>
      <PageHeader
        icon="storage"
        title="SharePoint opslag"
        subtitle="Vind grote bestanden en mappen, PowerPoint-versie-opblaas en media die naar de NAS moet — en open ze direct in SharePoint."
      />
      <SharePointAnalysis />
    </Box>
  );
}
